import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, Phone } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { BRAND } from "../lib/constants";

export default function SuccessPage() {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center" data-testid="success-page">
        <div className="max-w-[900px] mx-auto px-5 md:px-10 py-16 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#E60012] border-4 border-black mb-8">
            <CheckCircle2 size={36} strokeWidth={2.5} className="text-white" />
          </div>
          <div className="gd-tag text-[#E60012] mb-3">▌ Application received</div>
          <h1 className="font-display font-black text-5xl md:text-7xl tracking-tighter uppercase leading-[0.9] mb-6" data-testid="success-headline">
            You're<br />in the <span className="text-[#E60012]">queue</span>.
          </h1>
          <p className="text-black/65 text-lg max-w-xl mx-auto leading-relaxed mb-10">
            We've got your application. A team member will reach out within 3 hours during business hours. Keep your phone close — we move fast.
          </p>

          <div className="bg-[#0A0A0A] text-white p-6 md:p-8 border-2 border-black inline-flex flex-col items-start gap-3 text-left mb-10">
            <div className="gd-tag text-[#E60012]">Need to reach us first?</div>
            <a href={`tel:${BRAND.phone}`} className="font-display font-black text-2xl md:text-3xl tracking-tight inline-flex items-center gap-3" data-testid="call-link">
              <Phone size={22} /> {BRAND.phone}
            </a>
          </div>

          <div>
            <Link
              to="/"
              className="font-display font-bold uppercase tracking-wider px-8 py-4 border-2 border-black hover:bg-black hover:text-white gd-snappy inline-flex items-center gap-2"
              data-testid="back-home-btn"
            >
              Back to home <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
